import lodashGet from "lodash/get";
import React, { ComponentPropsWithoutRef } from "react";
import { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { getFormattedDegreeData } from "shared/helpers/profile/getFormattedDegreeData";
import { ProfileView } from "shared/mappers/database/profile/profile";
import { DeepKeys } from "shared/types/deepkeys";

export type PillarTableColumnProfileDegreeProps<T> = {
  pick: "degreeType" | "university" | "graduationDate";
} & PillarTableBaseColumnCellValuePathProps<T> &
  ComponentPropsWithoutRef<"div">;

const PillarTableColumnProfileDegree = <T,>({
  cellValuePath,
  pick,
  ...props
}: PillarTableColumnProfileDegreeProps<T>) => {
  const { rowValue } = usePillarTableRowContext();
  const profile = cellValuePath
    ? (lodashGet(rowValue, cellValuePath) as ProfileView)
    : (rowValue as ProfileView);
  const degree = profile?.societyUser?.degree ?? [];
  try {
    return <div {...props}>{getFormattedDegreeData(degree ?? [], pick)}</div>;
  } catch (error) {
    console.error("Error PillarTableColumnProfileDegree:", {
      error,
      rowValue,
      props: { cellValuePath, pick, ...props },
    });
    return <></>;
  }
};
export default PillarTableColumnProfileDegree;
